export const CheckMark = () => {
  return (
    <svg fill="none" height="84" viewBox="0 0 84 84" width="84" xmlns="http://www.w3.org/2000/svg">
      <rect fill="url(#paint0_linear_612_2830)" height="84" rx="42" width="84" />
      <path
        d="M53.3511 33.4863L37.743 49.0944L30.6484 41.9998"
        stroke="#032B49"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5"
      />
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_612_2830" x1="-33" x2="131.5" y1="-6" y2="118">
          <stop stopColor="#EEFB86" />
          <stop offset="0.423077" stopColor="#F4F4EF" />
          <stop offset="0.649038" stopColor="#E5EDF7" />
          <stop offset="1" stopColor="#C7E0FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
